<woa-modal-page-layout [title]="'woa.heading.order.extras.choose.title'" [translationParams]="{'name': groupName()}">
    <div class="extras" [ngClass]="{'with-images': anyHaveImages()}">
        @for (extraProduct of availableExtraProducts(); track extraProduct; let i = $index) {
            <div class="extra" id="extra-{{i}}">
                <woa-order-item-option-control [image]="menuModel.getMenuItemProductImage(extraProduct.menuItem)"
                                               [title]="menuModel.getMenuItemDisplayName(extraProduct.menuItem) || extraProduct.productLine.name"
                                               [price]="extraPrice()(extra(), extraProduct)"
                                               [showImage]="anyHaveImages()"
                                               [unavailable]="extraProduct.productLine.sellableId !== selectedExtraProduct().productLine.sellableId && extraProductAtLimit()(extraProduct)"
                                               [selected]="extraProduct.productLine.sellableId === selectedExtraProduct().productLine.sellableId"
                                               (onSelect)="selectExtra(extraProduct)"></woa-order-item-option-control>
            </div>
        }
    </div>
    <woa-button woa-page-footer-control id="confirm-changes-button"
                [label]="'woa.button.order.confirmChanges'"
                (onActivate)="dismiss(selectedExtraProduct())"></woa-button>
</woa-modal-page-layout>
